import type { FC } from "react";

import classNames from "classnames";

import type { Language } from "../../LanguageSelector";

import styles from "./LanguageSelectorListItem.module.scss";

type LanguageSelectorListItemProps = {
  language: Language;
  selectedLanguageCode?: string;
  onSelectLanguage: (language: Language) => void;
};

export const LanguageSelectorListItem: FC<LanguageSelectorListItemProps> = ({
  language,
  selectedLanguageCode,
  onSelectLanguage,
}) => {
  const isItemActive = language.associatedCookieValue === selectedLanguageCode;

  const handleSelectLanguage = () => {
    if (isItemActive) {
      return;
    }
    onSelectLanguage(language);
  };

  return (
    <li
      key={language.associatedCookieValue}
      className={classNames(styles.listItem, { [styles.listItemActive]: isItemActive })}
    >
      <button
        type="button"
        data-testid="languageSelectorLangBtn"
        className={classNames(styles.listItemBtn, {
          [styles.listItemBtnActive]: isItemActive,
        })}
        onClick={handleSelectLanguage}
      >
        {language.languageDisplayName}
      </button>
    </li>
  );
};
